module.exports = __webpack_public_path__ + "static/media/Benifits4.b4dc861b.png";